export const employee = {
  page: 1,
  take: 10,
  reserved: true,
  search: '',
  relations: ['user'],
  select: [
    'id',
    'code',
    'type',
    'user.id',
    'user.email',
    'user.avatar',
    'user.displayName',
    'user.phoneNumber',
    'user.type',
    'createdAt',
    'status',
  ],
  order: { name: 'createdAt', value: -1 },
};
